var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {PasswordRecoverWebAsync as InvokeAsync , PasswordRecoverWebSync as InvokeSync}

async function PasswordRecoverWebAsync(Email,Domain)
{
    var PasswordRecoverPromise = new Promise((resolve, reject) => {
        PasswordRecoverWebSync(Email,Domain,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await PasswordRecoverPromise;
}

function PasswordRecoverWebSync(Email,Domain,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/User/PasswordRecoverWeb',                
        data  : {
            Email : Email ,
            Domain: Domain,
            AppID : KEYS.AWS_APPID              
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
